<template>
  <div class="OrderDetailTabContainer" id="placement">
    <div v-if="layoutObj.layout.id !== 'n1-east'">
      <div v-if="layoutObj.layout.id !== 'n1-west'">
        <div v-if="layoutObj.layout.id !== 's1-east'">
          <div v-if="layoutObj.layout.id !== 's1-west'">
            <!-- <div class="InstructionContainer">
              <p class="InstructionMessage">
                このレイアウトパターンでは次の要素の表示仕様を選ぶ必要があります。
              </p>
            </div> -->
            <!-- 位表記-->
            <!-- <label class="FormGroup-Label">位表記</label>
            <div class="FormGroup-Form" id="underCharacterPlacementButton">
              <ButtonGroup>
                <VisualButton
                  v-for="option in underCharactersPlacement"
                  :key="option.label"
                  :text="option.label"
                  :isActive="option.value === form.underCharactersPlacement"
                  :variant="{ width: 'fit' }"
                  @click="_onClickUnderCharacterPlacementButton(option.value)"
                />
              </ButtonGroup>
            </div> -->
            <!--位表記:中心時-->
            <!-- <div
              class="underCharacterCenter"
              v-if="form.underCharactersPlacement === 'CENTER'"
            >
              <div class="FormGroup u-mt10 u-ml50">
                <label class="FormGroup-Label"></label>
                <div class="FormGroup-Form">
                  <GridContainer :column="2">
                    <VisualButton
                      v-for="option in underCharacters"
                      :key="option.label"
                      :text="option.label"
                      class="characterSankirtBtn"
                      :isActive="
                        option.value === $itaijiFM.getText(form.underCharacters)
                      "
                      :variant="{ width: 'fit' }"
                      @click="_onClickSankirtOptionButton(option.value)"
                    />
                  </GridContainer>
                </div>
              </div>
            </div> -->
            <!-- 俗名表記-->
            <!-- <div v-if="layoutObj.layout.id !== 'n2-east-3'">
              <div v-if="layoutObj.layout.id !== 'n2-west-2'">
                <div v-if="layoutObj.layout.id !== 'n2-west-3'">
                  <label class="FormGroup-Label">俗名の表記</label>
                  <div class="FormGroup-Form" id="secularNamePlacementButton">
                    <ButtonGroup>
                      <VisualButton
                        v-for="option in secularNamePrefixPlacement"
                        :key="option.label"
                        :text="option.label"
                        :isActive="
                          option.value === form.secularNamePrefixPlacement
                        "
                        :variant="{ width: 'fit' }"
                        @click="
                          _onClickSecularNamePlacementButton(option.value)
                        "
                      />
                    </ButtonGroup>
                  </div>
                </div>
              </div>
            </div> -->
            <!-- 享年表記-->
            <!-- <div v-if="layoutObj.layout.id !== 'n2-east' || layoutObj.layout.id !== 'n2-east-3' || layoutObj.layout.id !== 'n2-west-2' || layoutObj.layout.id !== 'n2-west-3'">
              <div v-if="layoutObj.layout.id !== 'n2-east-3'">
                <div v-if="layoutObj.layout.id !== 'n2-west-2'">
                  <div v-if="layoutObj.layout.id !== 'n2-west-3'">
                    <label class="FormGroup-Label">享年表記</label>
                    <div class="FormGroup-Form" id="ageAtDeathPlacementButton">
                      <ButtonGroup>
                        <VisualButton
                          v-for="option in ageAtDeathPrefixPlacement"
                          :key="option.label"
                          :text="option.label"
                          :isActive="
                            option.value === form.ageAtDeathPrefixPlacement
                          "
                          :variant="{ width: 'fit' }"
                          @click="
                            _onClickAgeAtDeathPlacementButton(option.value)
                          "
                        />
                      </ButtonGroup>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <!-- </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { produce } from "immer";
// Data Handler
import EntityFactory from "@/entities/entity.factory";
const orderOption = EntityFactory.create("orderOption");

// Components
// import VisualButton from "@/components/VisualButton";
// import ButtonGroup from "@/components/ButtonGroup";

// import GridContainer from "@/components/GridContainer";

export default {
  components: {
    // VisualButton,
    // ButtonGroup
    // GridContainer
  },
  props: {
    layoutId: {
      type: String,
      default: "",
    },
  },
  async created () {},
  mounted () {},
  data () {
    return {
      underCharactersPlacement: orderOption.underCharactersPlacement,
      underCharacters: orderOption.underCharacters,
      secularNamePrefixPlacement: orderOption.secularNamePrefixPlacement,
      // secularNamePrefixPlacement: orderOption.secularNamePrefixPlacement,
      // ageAtDeathPrefixPlacement: orderOption.ageAtDeathPrefixPlacement
    };
  },
  computed: {
    layoutObj: {
      get () {
        return this.$store.state.orderForm.orderTypeInput;
      },
    },
    ...mapState({
      orderType: state => state.orderForm.orderTypeInput,
    }),
    form: {
      get () {
        return this.$store.state.orderForm.detailInput;
      },
      set (value) {
        this.$store.commit("orderForm/setDetail", { ...value });
      },
    },
    ...mapGetters({
      detail: "orderForm/orderDetail",
      filteredFavoriteVariantCharacters: "orderForm/getFilteredFavoriteVariantCharacters",
    }),
  },
  methods: {
    // When you tap the 中央or霊ごと
    _onClickUnderCharacterPlacementButton (value) {
      this.form = { ...this.form, ...{ underCharactersPlacement: value } };
    },
    _onClickSankirtOptionButton (underCharacters) {
      const { toItaiji } = this.$itaijiFM;
      this.form = produce(this.form, d => {
        d.underCharacters = toItaiji(underCharacters, this.filteredFavoriteVariantCharacters);
      });
    },

    // When you tap the 中央or霊ごと
    _onClickSecularNamePlacementButton (value) {
      this.form = { ...this.form, ...{ secularNamePrefixPlacement: value } };
    },
    // When you tap the 中央or霊ごと
    _onClickAgeAtDeathPlacementButton (value) {
      this.form = { ...this.form, ...{ ageAtDeathPrefixPlacement: value } };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.underCharacterCenter {
  margin-left: 33%;
  margin-bottom: 10%;
}
.OrderDetailTabContainer > * + * {
  margin-top: 10px;
}
.characterSankirtBtn {
  width: 100px;
  height: 50px;
}
.InstructionContainer {
  width: 100%;
  height: 100%;
  display: flex;
  border: 2px solid $--color-primary;
  font-size: 13px;
  text-align: center;
  margin-bottom: 25px;
}

.InstructionMessage {
  margin-left: 5%;
  color: $--color-primary;
}
.FormGroup-Label {
  color: $--color-primary;
}
#placement .label {
  text-align: center;
  margin-top: 6px;
}
</style>
